import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import NoDataReceipt from './NoDataReceipt';
import { useDownloadVATReceipt } from './DownloadVATReceiptHook';
import { useTranslation } from 'react-i18next';

const DownloadVATReceipt = () => {
  const { t } = useTranslation();

  const { receipt, isUnauthorisedUser, isAPICalled, isAllowedToDownload } = useDownloadVATReceipt();

  return (
    <div className="download-receipt-container">
      {!isAPICalled && (
        <div className="loading-container">
          <div className="spinner"></div>
          <h2>{t('history.receipt.content.vatReceiptLoadingMessage')}</h2>
          <p>{t('history.receipt.content.vatReceiptDownloadMessage')}</p>
        </div>
      )}
      {isAPICalled && receipt === null && (
        <PDFViewer className="receiptItem">
          <NoDataReceipt isUnauthorisedUser={isUnauthorisedUser} isAllowedToDownload={isAllowedToDownload} />
        </PDFViewer>
      )}
    </div>
  );
};

export default DownloadVATReceipt;
